import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { generatePdfManually } from '../../commonApis'
import { dateString } from "../../components/util";
import { LoaderPopup } from '../LoaderPopup'

const GenerateButton = (props) => {
    const shipId = props.shipId || window.shipmentId;
    const customState = props.customState;
    const mrn = props.mrn;
    const [toggleLoader, setToggleLoader] = useState(false)
    const [loaderMsg, setLoaderMessage] = useState('Processing...')

    const toggleLoaderFunc = (msg, timer) => {
        var time = timer || 3000
        setToggleLoader(true)
        setLoaderMessage(msg)
        setTimeout(() => {
            setToggleLoader(false)
            setLoaderMessage('Loading...')
        }, time)
    }

    const clickHandler = async () => {
        
        await toggleLoaderFunc("Generating PDF...")
        let payload = {
            "pdfType": "CLIENT_PDF_CDS_UK",
            "shipmentId": shipId,
            "addDocumentNew": "TRUE",
            "countryCode": "GB",
            "extraData": {
                "declarationStatus": customState.replace("STATE_", ""),
                "statusDateTime": dateString(Date.now()),
                "mrn": mrn,
                "sendNotification": "false"
            }
        }
        const res = await generatePdfManually(payload);
        await toggleLoaderFunc("Please wait...")
        if(res?.data?.eventMessage?.code === 400){
            await toggleLoaderFunc("Failed to generate pdf, something went wrong.") 
        }else{
            await toggleLoaderFunc("PDF Generated successfully");
            await document.getElementById(`card-${shipId}`).click();
        }
        
    }
    
    return (
            <><Button
                size="mini"
                key="FILE"
                className="sv todo-button secondaryBtn"
                onClick={(e) => {
                    e.stopPropagation();
                    clickHandler();
                }}
            >
                {`GENERATE PDF`}
            </Button>
        {toggleLoader && <LoaderPopup loaderMsg={loaderMsg} />}
        </>
    );
}

export default GenerateButton;